import Typography from '@mui/material/Typography';



const ArticleText = (props: { children: JSX.Element | string | (JSX.Element | string)[] }) =>
{
  return(
    <Typography sx={{ fontSize: 17, lineHeight: 1.8, textAlign: 'justify' }}>
      {props.children}
    </Typography>);
};

export default ArticleText;
